export class CircularArray extends Array {
  public at(index: number) {
    const normalizedIndex = ((index % this.length) + this.length) % this.length;
    return this[normalizedIndex];
  }
}
